export default __webpack_public_path__ + "static/media/us-mo.74209ffb.svg";